/** CV order for dated entries: newest start first, a missing start last. Equal starts compare as 0, so a stable sort keeps their incoming order. */
export function byStartNewestFirst(a: string | null | undefined, b: string | null | undefined): number {
  return (b || "").localeCompare(a || "");
}

/** Stations newest start first, on a copy: genesis hands them over in entry order, and Apollo's arrays are frozen. */
export function newestStartFirst<T extends { startDate: { date: string } }>(rows: readonly T[] | null | undefined): T[] {
  return [...(rows ?? [])].sort((a, b) => byStartNewestFirst(a.startDate.date, b.startDate.date));
}
